<template>
    <el-container class="healthy page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">权益人信息</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="权益人用户ID、姓名"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">订单号</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="订单号"
                    v-model.trim="searchBox.userInfo"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">服务单号</span>
                <el-input
                    class="input-box"
                    clearable
                    placeholder="服务项目名称"
                    v-model.trim="searchBox.serverNumber"
                ></el-input>
            </div>
            <div class="search-item">
                <span class="label">管理机构</span>
                <el-select v-model="searchBox.supplier" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">分公司</span>
                <el-select v-model="searchBox.supplier" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>

            <div class="search-item">
                <span class="label">渠道</span>
                <el-select v-model="searchBox.supplier" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>

            <div class="search-item">
                <span class="label">申请状态</span>
                <el-select v-model="searchBox.type" clearable>
                    <el-option
                        v-for="item in statusArr"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </div>
            <div class="search-item">
                <span class="label">申请时间</span>
                <el-date-picker
                    v-model="timeCache.orderGeneration"
                    @change="
                        (e) =>
                            toChangeTime(
                                e,
                                'orderGenerationStart',
                                'orderGenerationEnd'
                            )
                    "
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="{
                        disabledDate(time) {
                            return time.getTime() > Date.now();
                        },
                    }"
                >
                </el-date-picker>
            </div>
            <el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
                >查询</el-button
            >
            <el-button
                v-auth="'sa_order_page'"
                type="primary"
                @click="() => ($root.showPage = false)"
                >重置</el-button
            >
            <el-button
                v-auth="'sa_order_export'"
                type="warning"
                @click="toExport"
                >导出数据</el-button
            >
        </div>
        <div class="cont-x">
            <div class="table-x" ref="tableBox">
                <el-table
                    v-loading="loading"
                    :data="tableData"
                    :height="tableHeight"
                    border
                    class="mb20"
                >
                    <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="60"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="orderNo"
                        align="center"
                        label="订单号"
                        width="200"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="服务单号"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="服务项目名称"
                    ></el-table-column>
                    <el-table-column
                        prop="rightsUserId"
                        align="center"
                        width="160"
                        label="权益人用户ID"
                    >
                        <template slot-scope="scoped">
                            <span>{{ scoped.row.rightsUserId ? scoped.row.rightsUserId : "--" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="权益人姓名"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="与权益人关系"
                    ></el-table-column>

                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="证件类型"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="证件号"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="联系电话"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="管理机构"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="分公司"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="保单号"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="产品名称"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="渠道"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="垫付申请时间"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="状态"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="状态更新时间"
                    ></el-table-column>
                    <el-table-column
                        prop="printNo"
                        align="center"
                        width="160"
                        label="供应商"
                    ></el-table-column>
                    <el-table-column align="center" width="160" label="操作">
                        <template slot-scope="scope">
                            <el-button
                                size="middle"
                                class="mb10"
                                type="text"
                                @click="showDetail(scope.row)"
                                >查看</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pagenation-x">
            <div class="pagination mb20">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="searchBox.pageNo"
                    :page-size.sync="searchBox.pageSize"
                    layout="total,  prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <drag-dialog
            title="住院垫付服务详情"
            v-model="dialogVisible"
        >
            <div class="dialog-list">
                <div class="title">就诊人信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">姓名：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">性别：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">年龄：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">手机号：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">证件类型：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">证件号：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">有无医保：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="title">保险信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">保单号：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">产品名称：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">管理机构：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                    <div class="dialog-list-title">渠道：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="title">申请信息</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">垫付申请日期：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">就诊医院：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">疾病诊断：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">是否报销：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">垫付结论：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">垫付金额：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">垫付日期：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">拒绝理由：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="title">服务评价</div>
                <div class="dialog-list-box">
                    <div class="dialog-list-title">用户评价：</div>
                    <div class="dialog-list-text">{{ dialogData.name }}</div>
                </div>
                <div class="title">服务轨迹</div>
                <div class="dialog-list-box">
                    <el-table
                        :data="dialogData.table"
                        border
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="date"
                            label="时间"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="状态"
                        ></el-table-column>
                        <el-table-column
                            prop="address"
                            label="备注"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
        </drag-dialog>
    </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import { dateFormat } from "@/assets/js/until.js";
export default {
    name: "expertAppointment",
    components: { dragDialog },
    data() {
        return {
            // table表格
            loading: false,
            tableData: [], // table数据
            total: 0,
            tableHeight: 0, // 表格高度
            // 查询条件
            timeCache: {}, // 时间缓存
            statusArr: [],
            searchBox: {
                pageSize: 10,
                pageNo: 1,
            }, // 搜索条件
            // 弹窗
            dialogVisible: false, // 弹窗visible
            dialogData: {}, // 弹窗中的数据
        };
    },
    mounted() {
        this.$nextTick(()=>{
            this.listenWindow()
            this.getData()
        })
    },
    created() {
        // 面包导航
        this.$root.breadList = [
            { name: "服务订单", link: "" },
            { name: "住院垫付订单", link: "" },
        ];
    },
    methods: {
        //窗口改变，重新取得高度
        listenWindow() {
            this.tableHeight = this.$refs.tableBox.offsetHeight;
            window.addEventListener('resize', ()=>{
                clearTimeout(this.resizeFlag)
                                    this.resizeFlag = setTimeout(() => {
                    try {
                        this.tableHeight = this.$refs.tableBox.offsetHeight;
                    } catch (error) {}
                }, 300);
            })
        },
        /**
         * 显示弹窗
         */
        showDetail(data) {
            this.dialogVisible = true;
            this.dialogData = data;
        },
        /**
         * 搜索按钮
         */
        toSearch() {
            this.searchBox.pageNo = 1;
            this.getData();
        },
        /**
         * 导出数据
         */
        toExport() {
            console.log("导出");
        },
        /**
         * 获取数据
         */
        getData() {
            this.tableData = [{}];
            console.log("获取数据");
        },
        /**
         * 换页
         */
        handleCurrentChange(val) {
            this.searchBox.pageNo = val;
            this.getData();
        },
        /**
         * 时间回调函数
         */
        toChangeTime(val, startName, endName) {
            console.log(val);
            if (val && val.length) {
                this.searchBox[startName] = dateFormat(val[0]);
                this.searchBox[endName] = dateFormat(val[1]);
            } else {
                this.searchBox[startName] = "";
                this.searchBox[endName] = "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.dialog-list {
    .title {
        height: 30px;
        line-height: 30px;
        margin-bottom: 20px;
        font-weight: bold;
        padding-left: 20px;
        margin-top: 18px;
        position: relative;
        &::before {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 8px;
            background-color: $theme;
        }
    }
    .dialog-list-box {
        padding-bottom: 10px;
        display: flex;
        .dialog-list-title {
            padding-left: 20px;
            width: 100px;
            white-space: nowrap;
            text-align: right;
        }
        .dialog-list-text {
            flex: 1;
        }
    }
}
.cont-x {
    flex: 1;
    flex-shrink: 0;
    .table-x {
        height: 100%;
    }
}
</style>